import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";
import styles from "./ToggleSwitch.module.scss";
import { combineClasses } from "@/lib/utils";

export interface ToggleSwitchProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  wrapperClassName?: string;
}

const ToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(
  ({ className = "", wrapperClassName = "", id, ...props }, ref) => {
    return (
      <span className={combineClasses(styles.toggleSwitch, wrapperClassName)}>
        <input
          ref={ref}
          id={id}
          type="checkbox"
          className={className}
          {...props}
        />
        <span className={styles.toggleTrack} />
      </span>
    );
  }
);

ToggleSwitch.displayName = "ToggleSwitch";

export default ToggleSwitch;
